const Resources = {

    table_headers: [
        // {
        //     name: 'Select',
        // },
        {
            text: 'Walking #',
            value: 'walking_number',
        },
        {
            text: '#Room',
            value: 'door_number',
        },
        {
            text: 'Description',
            value: 'custom_description',
        },
        {
            text: 'Task',
            value: 'task',
        },
        {
            text: 'Daily Min',
            value: 'daily_minutes',
        },
        {
            text: 'Sq. Footage',
            value: 'sq_ft',
        },
        {
            text: 'Frequency',
            value: 'frequency',
        },
        {
            text: 'Days Assigned',
            value: 'days_assigned',
        },
        {
            text: 'Associated Assignments',
            value: 'associated_assignments',
        },
        {
            text: 'Group',
            value: 'work_group',
        },
    ],

    week_table_headers: [
        {
            name: 'Sun'
        },
        {
            name: 'Mon'
        },
        {
            name: 'Tue'
        },
        {
            name: 'Wed'
        },
        {
            name: 'Thu'
        },
        {
            name: 'Fri'
        },
        {
            name: 'Sat'
        },
    ],

    filter_options:
    {
        projects: false,
        
    },
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Daily Assignments',
            href:   `/assignment-daily-assignments`,
            arrow:  "<span class='slash'>/</span>",
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    freq_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    assigned_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

}

export default Resources;